<script lang="ts">
  import { Globe } from 'lucide-svelte';
  import { locale, t, LOCALES, type LocaleCode } from '$lib/i18n';
  import { updateMyLocale } from '$lib/api/me';
  import { session } from '$lib/state/session.svelte';

  const { compact = false, onLoginScreen = false }: { compact?: boolean; onLoginScreen?: boolean } = $props();

  let open = $state(false);

  const currentLabel = $derived(LOCALES.find((l) => l.code === locale.current)?.labelKey ?? 'lang.english');

  async function pick(code: LocaleCode) {
    open = false;
    if (code === locale.current) return;
    locale.set(code, { fromLoginScreen: onLoginScreen });
    if (!onLoginScreen && session.me) {
      try {
        const updated = await updateMyLocale(code);
        session.setMe(updated);
        locale.clearLoginOverride();
      } catch {
        // localStorage + UI already updated; server sync can retry on next change.
      }
    }
  }
</script>

<div class="relative">
  <button
    type="button"
    class="flex shrink-0 items-center gap-1.5 rounded-lg px-2 py-1.5 text-navy hover:bg-toyama-light-carbon {compact
      ? 'h-11 min-w-[44px] justify-center px-2'
      : 'min-h-[44px]'}"
    aria-label={t('lang.label')}
    aria-haspopup="listbox"
    aria-expanded={open}
    onclick={() => (open = !open)}
  >
    <Globe class="h-4 w-4 shrink-0" />
    {#if !compact}
      <span class="hidden text-[12px] font-medium sm:inline">{t('lang.label')}</span>
    {/if}
    <span class="text-[12px] font-semibold">{t(currentLabel)}</span>
  </button>

  {#if open}
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div class="fixed inset-0 z-30" role="presentation" onclick={() => (open = false)}></div>
    <ul
      class="tym-card absolute right-0 top-full z-40 mt-1 min-w-[148px] overflow-hidden py-1 shadow-[0_8px_24px_rgba(16,34,58,.15)]"
      role="listbox"
      aria-label={t('lang.label')}
    >
      {#each LOCALES as loc (loc.code)}
        <li role="option" aria-selected={locale.current === loc.code}>
          <button
            type="button"
            class="block w-full px-3 py-2 text-left text-[13px] hover:bg-toyama-light-carbon {locale.current === loc.code
              ? 'font-semibold text-toyama-teal'
              : 'text-navy'}"
            onclick={() => pick(loc.code)}
          >
            {t(loc.labelKey)}
          </button>
        </li>
      {/each}
    </ul>
  {/if}
</div>
